<template>
  <avs-card class="pb-4">
    <template v-slot:title>
      <v-toolbar
        class="mt-4 custom-toolbar"
        elevation="0"
      >
        <v-text-field
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
          :label="$t('commons.search')"
          v-model="search"
        />
        <avs-button
          color="success"
          iconI="mdi-file-excel"
          text
          :loading="exportingExcel"
          :name="$t('Excel')"
          :spantext="$t('Exporter la liste des clients en Excel')"
          @click="handleExportExcel"
        >
          <template v-slot:name>{{ $t("Excel") }}</template>
        </avs-button>
      </v-toolbar>
    </template>
    <template v-slot:content>
      <v-data-table
        class="ma-10"
        :no-data-text="$t('messages.information.no_data')"
        :headers="headers"
        :items="inspections"
        :search="search"
        item-text="text"
        :loading-text="$t('categories.inspection.loading')"
        :no-results-text="$tc('categories.inspection.name', 0)"
        :loading="loading"
        disable-pagination
        hide-default-footer
        @dblclick:row="($event, { item }) => handleInspectionEdit(item)"
      >
        <template v-slot:item.start_date="{ item }">
          {{ toDatetime(item.start_date) }}
        </template>
        <template v-slot:item.end_date="{ item }">
          {{ toDatetime(item.end_date) }}
        </template>
        <template v-slot:item.status="{ item }">
          <component :is="handleStatusComponent(item)" />
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-end">
            <avs-editButton
              @click.stop="handleInspectionEdit(item)"
              :spantext="
                $t('actions.edit', { entity: $tc('categories.inspection.name', 1).toLowerCase() })
              "
            />
            <avs-deleteButton
              @click.stop="handleOpenDeleteDialog(item)"
              :spantext="
                $t('actions.delete', {
                  entity: $tc('categories.inspection.name', 1).toLowerCase()
                })
              "
            />
          </div>
        </template>
      </v-data-table>
      <avs-deleteDialog
        v-model="deleteDialogIsOpen"
        @cancel="handleCancel"
        @delete="handleDelete"
        resource="inspection"
      />
    </template>
  </avs-card>
</template>

<script>
import { Closed, Ongoing, Overdue, Pending } from "@/components/generics/status"
import { CustomerService, ProjectService } from "@/services"
import { toDatetime } from "@/utils/datetime"

export default {
  name: "AllInspections",
  components: { Closed, Ongoing, Overdue, Pending },
  data() {
    return {
      deleteDialogIsOpen: false,
      headers: [
        { text: this.$t("Nom"), value: "first_name", class: "min-width-200" },
        { text: this.$t("Prenom"), value: "last_name", class: "min-width-150" },
        { text: this.$t("Email"), value: "email", class: "min-width-150" },
        { text: this.$t("N° Téléphone"), align: "center", value: "phone_number" },
        {
          text: this.$t("commons.actions"),
          sortable: false,
          value: "actions",
          align: "right",
          width: 200
        }
      ],
      inspections: [],
      loading: false,
      exportingExcel: false,
      search: "",
      selectedItem: null
    }
  },
  created() {
    this.getAllInspections()
  },
  methods: {
    getAllInspections() {
      this.loading = true
      CustomerService.getAllInspections().then(response => {
        this.inspections = response
        this.loading = false
      })
    },
    handleStatusComponent(item) {
      return item.status
    },
    async setStoreFromProjectId(projectId) {
      return ProjectService.get(this, null, projectId).then(project => {
        this.$store.commit("app/setCompany", project.company)
        this.$store.commit("app/setProject", project)
      })
    },
    async handleInspectionEdit(item) {
      this.setStoreFromProjectId(item.event.id).then(() => {
        this.$router.push({ name: "Customers", params: { id: item.id } })
      })
    },
    async handleInspectionJoin(item) {
      this.setStoreFromProjectId(item.event.id).then(() => {
        this.$router.push({ name: "InspectionMeeting", params: { id: item.id, uuid: item.uuid } })
      })
    },
    handleOpenDeleteDialog(item) {
      this.deleteDialogIsOpen = true
      this.selectedItem = item
    },
    handleCancel() {
      this.deleteDialogIsOpen = false
    },
    handleDelete(item) {
      CustomerService.remove(this, this.selectedItem.id).then(r => {
        this.inspections = this.inspections.filter(nc => nc.id !== this.selectedItem.id)
        let message = this.$t("messages.success.deleted", {
          entity: this.$tc("categories.inspection.name", 1)
        })
        this.notify(message, "success")
      })
      this.deleteDialogIsOpen = false
    },
    notify(message, color) {
      this.$store.commit("app/message", { msg: message, color: color })
    },
    isInspectionOver(item) {
      return ["Closed", "Overdue"].includes(item.status)
    },
    async handleExportExcel() {
      this.exportingExcel = true
      try {
        await CustomerService.exportExcel()
      } catch (e) {
        this.$store.commit("app/message", {
          msg: this.$t("Erreur lors de l'export Excel"),
          color: "error"
        })
      } finally {
        this.exportingExcel = false
      }
    },
    toDatetime
  }
}
</script>
